import React, { Component } from "react";
import { applyDataTable } from '../../../custom/dataTable';
import Delete from '../../../../assets/img/svg/delete.svg';
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import del from "../../../../assets/img/svg/Del.svg";
import { connect } from "react-redux";
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { getlookupdocinfo, getlookuppageinfo } from "../../../../actions/ProjectMasterDataAction";
import { CssTextField, CssTextFieldLast, CssTextFieldRow } from "../../../custom/textField"

class ProjectMaster extends Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.state = {
            isMobile: false,
            Ship_List: [],
            showrow: false,
            UserRole: "",
            TypeId: 0,
            render: false,
            index: 0,
            name: "",
            nameError: false,
            section: "",
            DeleteId: 0,
            autoFocus: false,
            autoFocus1: false,
            index: 0,
            selectionStart: 0,
            update: "",
            Pagination: {
                "TotalPages": 0
            },
            response: 0,
            searchData: {
                ProjectId: 0,
                Typeid: 0,
                isMasterData: true,
                PageNumber: 1,
                PageSize: 100,
            },
            FocusedId: 0,
            newpostdata: {
                "ProjectId": 0,
                "TypeId": 0,
                "LookupName": "",
                "Section": "",
                "CreatedBy": "",
                "ModifiedBy": "",
            },
            postdataname: {
                "Id": 0,
                "Name": "",
                "Section": "",
                "Comments": "",
                "Status": "",
            }
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.getTypes("DocumentTypes")
        this.state.searchData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.newpostdata.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.newpostdata.CreatedBy = localStorage.getItem("UserRoles");
        this.state.newpostdata.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        // this.dataTable(this.state.searchData)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getTypes = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/type?type=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (response.data.length > 0) {
                        let type = response.data.filter((val) => val.Name == "PreBeachingDocument")
                        this.state.searchData.Typeid = type[0].Id;
                        this.state.newpostdata.TypeId = type[0].Id;
                        this.state.TypeId = type[0].Id;
                        this.setState({})
                    }
                    this.dataTable(this.state.searchData)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    dataTable = (data) => {
        let apiUrl = API.GET_DOCUMENTSNAME + '?ProjectId=' + data.ProjectId + '&Typeid=' + data.Typeid + '&isMasterData=' + data.isMasterData + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.Pagination.TotalPages = response.data.Pagination.TotalPages;
                    this.state.dataList = [];
                    this.setState({})
                    {
                        response.data?.Data && response.data?.Data.map((a) => (
                            a.Items && a.Items.map((s) => (
                                this.state.dataList.push(s)
                            ))
                        ))
                    }
                    this.state.dataList.push({
                        Comments: null,
                        Id: 0,
                        Name: "",
                        Section: "",
                        Status: null
                    })
                    this.setState({})
                    // this.state.dataList.sort((a, b) => {
                    //     return a.Id - b.Id;
                    // });
                    this.state.render = true;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#PROMAS2 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Promaster2 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Promaster22").addClass("d-none");
        $("#Promaster22").removeClass("d-block");
        this.props.dispatch({ type: "LOOKUP_DATAS", data: [] });
    }

    sidebar = () => {
        this.props.navigate("/sidebarprojectmasterdata");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

        $("#PROMAS2 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Promaster2 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Promaster22").removeClass("d-none");
        $("#Promaster22").addClass("d-block");
    };

    post_data = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/ProjectLookups';
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.dataList.map((i) => (
                        i.Id == 0 ? i.Id = response.data : <></>
                    ))
                    this.setState({})
                    this.state.actNameFocus = false;
                    document.getElementById("actName" + response.data).focus()
                    this.state.nameError = false;
                    // this.state.autoFocus = false;
                    this.state.name = "";
                    this.state.section = "";
                    // this.state.index = response.data;
                    this.state.showrow = false;
                    let id = this.state.dataList.filter((i) => i.Id == 0)
                    if (id.length == 0) {
                        this.state.dataList.push({
                            Comments: null,
                            Id: 0,
                            Name: "",
                            Section: "",
                            Status: null
                        })
                    }
                    // this.state.dataList.sort((a, b) => {
                    //     return a.Id - b.Id;
                    // });
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    put_data = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/UpdateProjectLookupField';
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.autoFocus = false;
                    this.state.autoFocus1 = false;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    OpenPopup = (Id) => {
        this.state.DeleteId = Id;
        this.setState({})
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deleteopalookdocs(this.state.DeleteId)
    }

    deleteopalookdocs = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/RemoveProjectLookups?projectLookupId=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.index = 0;
                    this.setState({})
                    this.dataTable(this.state.searchData)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    hoverHeight = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.HoverId = i.Id;
        if (data > data1) {
            this.state.Rows = data + 1;
        }
        else {
            this.state.Rows = data1 + 1;
        }
        this.setState({})
    }

    hoverHeight1 = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.FocusId = i.Id;
        if (data > data1) {
            this.state.Rows1 = data + 1;
        }
        else {
            this.state.Rows1 = data1 + 1;
        }
        this.setState({})
    }

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.dataTable(this.state.searchData)
    }
    handleFocusDescription = (e, str, val) => {
        this.setState({ index: str.Id })
        if (str.Id == 0 && e.target.value.trim().length > 0) {
            document.getElementById('DescName').selectionStart = e.target.value.trim().length;
            document.getElementById('DescName').focus()
        }
    }

    handleFocusDescription1 = (e, str, val) => {
        this.setState({ index: str.Id })
        if (e.target.value.trim().length > 0) {
            document.getElementById('DescName' + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById('DescName' + str.Id).focus()
        }
    }

    handleFocusNameChange = (e, str, val) => {
        this.setState({ index: str.Id })
        if (e.target.value.trim().length > 0) {
            document.getElementById("actName" + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById("actName" + str.Id).focus()
        }
    }

    handleFocusActChange = (e, str, val) => {
        this.setState({ actNameFocus: true, index: str.Id })
        if (str.Id == 0 && e.target.value.trim().length > 0) {
            document.getElementById('actName').selectionStart = e.target.value.trim().length;
            document.getElementById('actName').focus()
        }
    }

    handlePasteChange = (event, str, val, index) => {
        if (str.Id == 0 && event.target.value.trim() != "") {
            this.state.newpostdata.LookupName = event.clipboardData.getData("text").trim();
            this.state.newpostdata.Section = str.Section.trim();
            this.setState({})
            // this.post_data(this.state.newpostdata)
        }
        this.state?.dataList?.map((i) => (
            i.Id == 0 ? i.Name.trim() == "" ? (
                this.post_data(this.state.newpostdata),
                this.state.actNameFocus = true
            )
                : "" : ""
        ))
        this.setState({})
    }

    handleInputChange = (e, str, val, index) => {
        if (val == "Name") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Name = e.target.value : ""
            ))
            if (str.Id == 0 && e.target.value.length == 1 && e.target.value.trim() != "") {
                this.state.newpostdata.LookupName = e.target.value;
                this.state.newpostdata.Section = str.Section.trim();
                this.setState({});
                this.post_data(this.state.newpostdata)
                this.state.actNameFocus = true
            }
            if (e.target.value.trim() == "" && str.Id != 0) {
                this.state.index = str.Id;
                this.setState({})
                document.getElementById("actName" + str.Id).focus();
            }
            if (str.Id == 0 && str.Name.trim() != "") {
                this.state.showrow = true;
                this.state.autoFocus = true;
                this.state.nameError = true;
                // this.state.selectionStart = this.inputRef.current.selectionStart;
                // var el = document.getElementById('docName');
                // el.value = e.target.value;
                // el.focus();
                // if (typeof el.selectionStart == "number") {
                //     el.selectionStart = el.selectionEnd = e.target.value.length;
                // } else if (typeof el.createTextRange != "undefined") {           
                //     var range = el.createTextRange();
                //     range.collapse(false);
                //     range.select();
                // }
                // ele.setSelectionRange(e.target.value.length, e.target.value.length);
                // var len = e.target.value.length+1;
                // document.getElementById("docName").focus();
                // document.getElementById("docName").setSelectionRange(len, len);
            }
        }
        if (val == "Section") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Section = e.target.value : ""
            ))
            if (str.Id == 0 && str.Name.trim() == "") {
                this.state.autoFocus1 = true;
            }
        }
        this.setState({})
    }

    handleInputChange1 = (e, str, val) => {
        if (str.Name.trim() == "") {
            this.deleteopalookdocs(str.Id)
        }
        if (str.Name.trim() != "") {
            let data = {
                Comments: str.Comments == null ? "" : str.Comments,
                Id: str.Id,
                Name: str.Name.trim(),
                Section: str.Section.trim(),
                Status: null
            }
            this.put_data(data)
            this.state.autoFocus1 = false;
            this.setState({})
        }
        if (val == "Name") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Name = e.target.value.trim() : ""
            ))
        }
        if (val == "Section") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Section = e.target.value.trim() : ""
            ))
        }
        this.setState({ HoverId: 0, index: 0, FocusId1: 0, })
        this.setState({})
    }

    postDataBlur = (e, str, val) => {
        if (val == "Name") {
            if (str.Id != 0 && e.target.value.trim() != "") {
                let data = {
                    Comments: str.Comments,
                    Id: str.Id,
                    Name: str.Name.trim(),
                    Section: str.Section.trim(),
                    Status: null
                }
                this.put_data(data)
                // this.state.newpostdata.LookupName = e.target.value.trim();
                // this.state.newpostdata.Section = this.state.section.trim();
                // this.setState({})
                // this.post_data(this.state.newpostdata)
                // this.state.showrow = false;
                // this.state.nameError = false;
                // this.state.actNameFocus = false;
                // this.state.name = "";
                // this.state.section = "";
                // this.state.dataList.map((i) => (
                //     i.Id == 0 ? i.Id = this.state.response : <></>
                // ))
                // let data = {
                //     Comments: str.Comments,
                //     Id: this.state.response,
                //     Name: str.Name.trim(),
                //     Section: str.Section.trim(),
                //     Status: null
                // }
                // this.put_data(data)
                // this.state.dataList.push({
                //     Comments: null,
                //     Id: 0,
                //     Name: "",
                //     Section: "",
                //     Status: null
                // })
                // this.state.dataList.sort((a, b) => {
                //     return a.Id - b.Id;
                // });
                this.setState({})
            }
            if (e.target.value.trim() == "") {
                this.state.dataList.map((i) => (
                    i.Id == 0 ? (
                        i.Comments = null,
                        i.Id = 0,
                        i.Name = "",
                        i.Section = "",
                        i.Status = null
                    ) : ""
                ))
                this.state.showrow = false;
                this.state.nameError = false;
                this.state.name = "";
                this.state.section = "";
            }
            this.state.response = 0;
            this.setState({})
        }
        if (val == "Section") {
            let data = {
                Comments: str.Comments,
                Id: str.Id,
                Name: str.Name.trim(),
                Section: str.Section.trim(),
                Status: null
            }
            this.put_data(data)
        }
        this.setState({})
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {this.state.isMobile ?
                    <>
                        <div className="row border-bottom w-100 mt-4">
                            <div className="col-6 mt-auto">
                                <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem onClick={() => this.sidebar()} >
                                        <ListItemText id="PROMAS2" className='  textNaviIcon' primary="Master Data" />
                                        <NavigateNextIcon id="PROMAS2" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                        <Divider className='' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-6 pt-2 mt-5 ">
                                <h4>Pre-Beaching Documents</h4>
                            </div>
                        </div>
                    </>
                    :
                    <></>
                }
                <div className="ml-auto" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Pre-Beaching Documents</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12 mb-5">
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table id="DocsTable" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="49%" style={{ minWidth: '49%', maxWidth: '49%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Document Name</span></th>
                                            <th className="border-top border-right" width="48%" style={{ minWidth: '48%', maxWidth: '48%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Section Name</span></th>
                                            <th className="border-top border-right" width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataList && this.state?.dataList.map((i, index) => (
                                            i.Id != 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        {/* <div className={(this.state.HoverId == i.Id || this.state.index == i.Id) ? "border-top border-bottom border-left border-right" : ""}> */}
                                                        <div className={(this.state.HoverId == i.Id || this.state.index == i.Id) ? "border-bg" : "border-bg-none"}>
                                                           {/* {(i.Name == "") ?
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    autoFocus={this.state.index == i.Id ? true : false}
                                                                    id={"actName" + i.Id}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                    style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                    onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                                    onChange={(e) => this.handleInputChange(e, i, 'Name', index)}
                                                                    onBlur={(e) => this.handleInputChange1(e, i, 'Name')}
                                                                    value={i.Name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} /> : */}
                                                            <CssTextFieldRow
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                autoFocus={this.state.index == i.Id ? true : false}
                                                                id={"actName" + i.Id}
                                                                onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                                onFocusOut={(e) => this.setState({ FocusId1: 0 })}
                                                                onChange={(e) => this.handleInputChange(e, i, 'Name', index)}
                                                                onBlur={(e) => this.handleInputChange1(e, i, 'Name')}
                                                                value={i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                        </div>
                                                        {/* } */}
                                                        {(i.Name == "") ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Document Name is required</span> : <></>}
                                                    </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right`}>
                                                        {/* <div className={(this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) ? "border-top border-bottom border-left border-right" : ""}> */}
                                                        <div className={(this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) ? "border-bg" : "border-bg-none"}>
                                                            <CssTextFieldRow
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id={"actDesc" + i.Id}
                                                                onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                                onMouseLeave={(e) => this.setState({ HoverId1: 0 })}
                                                                onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                onChange={(e) => this.handleInputChange(e, i, 'Section')}
                                                                onBlur={(e) => this.handleInputChange1(e, i, 'Section')}
                                                                value={i.Section}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                        </div>
                                                    </td>
                                                    <td className="align-middle text-center border-right"><img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                </tr> : <></>
                                        ))}
                                        {this.state?.dataList && this.state?.dataList.map((i) => (
                                            i.Id == 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        {(i.Name == "") ?
                                                            <CssTextFieldLast
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id="actName"
                                                                autoFocus={this.state.actNameFocus}
                                                                onFocus={(e) => this.handleFocusActChange(e, i, 'Name')}
                                                                onChange={(e) => this.handleInputChange(e, i, 'Name')}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                onPaste={(e) => this.handlePasteChange(e, i, 'Name')}
                                                                value={i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} /> :
                                                            <CssTextField
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id="actName"
                                                                autoFocus={this.state.actNameFocus}
                                                                onFocus={(e) => this.handleFocusActChange(e, i, 'Name')}
                                                                onChange={(e) => this.handleInputChange(e, i, 'Name')}
                                                                onPaste={(e) => this.handlePasteChange(e, i, 'Name')}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                value={i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />}
                                                        {((i.Name.trim() == "" && this.state.nameError == true) || (i.Name.trim() == "" && i.Section.trim() != "")) ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Document Name is required</span> : <></>}
                                                    </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        <CssTextFieldLast
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            id="DescName"
                                                            onFocus={(e) => this.handleFocusDescription(e, i, 'Section')}
                                                            onChange={(e) => this.handleInputChange(e, i, 'Section')}
                                                            onBlur={(e) => this.postDataBlur(e, i, 'Section')}
                                                            value={i.Section}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} />
                                                    </td>
                                                    <td className="align-middle text-center border-right">
                                                        {(i.Name.trim() != "" || (i.Name.trim() == "" && this.state.nameError == true)) ? <img src={Delete} className="cursorPointer" /> : <></>}
                                                    </td>
                                                </tr> : <></>
                                        ))}
                                        {this.state.showrow ?
                                            <tr className="border-top">
                                                <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                    <CssTextFieldLast
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        size="small"
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </td>
                                                <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                    <CssTextFieldLast
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        size="small"
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </td>
                                                <td className="align-middle text-center border-right">
                                                </td>
                                            </tr> : ""}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${classes.pagination}`}>
                    <div className={`${classes.paginationItem}`}>
                        {this.state.searchData.PageNumber == 1 ? <></> :
                            <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                        <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                        {(this.state.searchData.PageNumber == this.state.Pagination?.TotalPages) || (this.state.Pagination?.TotalPages == 0) ? <></> :
                            <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        Project_Master: state.ProjectMasterDataReducer.Project_Master,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProjectMaster))
);
